import React from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App';

if (document.getElementById('v3componentlibtest')) {
  const root = createRoot(document.getElementById('v3componentlibtest'));
  root.render(<App />);
}
